// extracted by mini-css-extract-plugin
export var cartIcon = "_nz-0";
export var cartIconContainer = "_nz-1";